import React, { useEffect, useState } from 'react';
import AlertModal from "./AlertModal";
import academicCitationService from '../../services/AcademicCitationService';
import AppLoading from './loading/AppLoading';
import './AcademicCitationModal.scss';

const AcademicCitationModal = ({ show, onHide, testId }) => {
    const [citationData, setCitationData] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    useEffect(() => {
        if (show && testId) {
            fetchCitation();
        } else if (!show) {
            setCitationData(null);
            setError(null);
        }
    }, [show, testId]);

    const fetchCitation = async () => {
        setLoading(true);
        setError(null);
        try {
            const response = await academicCitationService.getAcademicCitation(testId);
            console.log('academicCitationService', response?.data)
            if (response?.success && response?.data?.CitationText) {
                setCitationData(response?.data);
            } else {
                setError('Failed to load academic citation.');
            }
        } catch (err) {
            console.error('Error fetching academic citation:', err);
            setError('An error occurred while fetching academic citation.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <AlertModal
            show={show}
            title={citationData?.Message?.Title || 'Academic Citation'}
            confirmBtnText="Close"
            showConfirm={true}
            showCancel={false}
            showCloseButton={true}
            onConfirm={onHide}
            onClose={onHide}
            closeOnClickOutside={true}
            confirmBtnCssClass="btn btn-secondary"
            containerClassName="academic-citation-modal"
        >
            {loading && (
                <div className="text-center py-4">
                    <AppLoading />
                </div>
            )}

            {error && (
                <div className="alert alert-danger" role="alert">
                    {error}
                </div>
            )}

            {!loading && !error && citationData?.CitationText && (
                <div className="academic-citation-content">
                    {citationData?.CitationText.map((citation, index) => (
                        <p key={index} className="mb-2">{citation}</p>
                    ))}
                </div>
            )}

            {!loading && !error && !citationData?.CitationText && (
                <div className="text-center text-muted">
                    No citation data available.
                </div>
            )}
        </AlertModal>
    );
};

export default AcademicCitationModal;
